import { MobileStepper, styled } from '@mui/material';

export const StyledMobileStepper = styled(MobileStepper)(({ theme }) => ({
    '&.MuiPaper-root.MuiMobileStepper-root': {
        position: 'unset',
        padding: 0,
        width: '100%',
        backgroundColor: 'unset',
    },
    '& .MuiMobileStepper-dot': {
        marginInline: theme.spacing(1.75),
        height: theme.spacing(1.5),
        width: theme.spacing(1.5),
    },
}));
